import { border, color, layout, space, system, typography, variant } from 'styled-system';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import StyledSystemPropTypes from '@styled-system/prop-types';

const baseHeadingStyles = css`
  font-family: ${({ theme }) => theme.fonts.heading};
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  line-height: ${({ theme }) => theme.lineHeights.tight};
  margin: 0;
`;

const textDecoration = system({
  textDecoration: true,
});

const textTransform = system({
  textTransform: true,
});

const headingVariants = variant({
  scale: 'headings',
  variants: {
    h1: {
      fontSize: [7, 8, null, 9],
    },
    h2: {
      fontSize: [6, 7, null, 8],
    },
    h3: {
      fontSize: [5, 6, null, 7],
    },
    h4: {
      fontSize: [4, 5, null, 6],
    },
    h5: {
      fontSize: [3, 4, null, 5],
    },
  },
});

const elementMap = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
};

const Heading = styled.h2.attrs(({ as, variant: headingVariant }) => ({
  as: as || elementMap[headingVariant],
}))`
  ${baseHeadingStyles};
  ${headingVariants};
  ${border};
  ${color};
  ${layout};
  ${space};
  ${textDecoration};
  ${textTransform};
  ${typography};
`;

Heading.defaultProps = {
  variant: 'h2',
};

Heading.propTypes = {
  variant: PropTypes.string, // Need the flexibility to add project level variants
  ...StyledSystemPropTypes.space,
  ...StyledSystemPropTypes.typography,
  ...StyledSystemPropTypes.color,
};

export { Heading, headingVariants, baseHeadingStyles };
